var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorBarLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: 8,
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    gradientUnits: "userSpaceOnUse",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "#FCD000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "14.28%",
    stopOpacity: 1,
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.56%",
    stopOpacity: 1,
    stopColor: "#FF253A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.85%",
    stopOpacity: 1,
    stopColor: "#FF37A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "57.13%",
    stopOpacity: 1,
    stopColor: "#A400E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71.42%",
    stopOpacity: 1,
    stopColor: "#0086FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.70%",
    stopOpacity: 1,
    stopColor: "#00D604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    stopColor: "#FCD000"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 8,
    fill: "url(#gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorBarLoading);
export default __webpack_public_path__ + "static/media/color-bar-loading.1075efab9b8f77cc8cf99c286bfc471a.svg";
export { ForwardRef as ReactComponent };